import { Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { TypeUtilService } from '@core/services/utils/type-util.service';

import { RestrictAccountModalComponent } from '@pages/product/modals/restrict-account/restrict-account-modal.component';

import { Product } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseRestrictionCommand } from './base-restriction.command';
import { RestrictionCommandResult } from './restriction-command.interface';

@Injectable({ providedIn: 'root' })
export class RestrictAccountCommand extends BaseRestrictionCommand {
  readonly type = 'restrictAccount';
  readonly title = 'Ограничить счет';
  readonly icon = undefined; // Нет иконки, используется красный цвет
  readonly isDangerous = true; // Красный цвет, без иконки
  readonly settingsNames = undefined;
  readonly group = 'blocking';
  readonly order = 5;
  readonly disabledColor = '#BEC9D8';

  constructor(
    private modalController: ModalController,
    commandAvailabilityService?: CommandAvailabilityService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: { data: Product }): Promise<RestrictionCommandResult> {
    const product = context.data;

    try {
      const modal = await this.modalController.create({
        component: RestrictAccountModalComponent,
        handle: false,
        cssClass: 'custom',
        initialBreakpoint: 1,
        componentProps: {
          product: product,
          staticHeight: true
        }
      });

      await modal.present();

      const { data } = await modal.onDidDismiss();

      return {
        success: data?.success || false,
        shouldCloseParent: data?.success || false,
        message: data?.success ? 'Счет успешно ограничен' : undefined
      };
    } catch (error) {
      console.error('Error opening restrict account modal:', error);

      return {
        success: false,
        shouldCloseParent: false
      };
    }
  }

  /**
   * При forbiddenChange команда должна быть disabled (но видимой)
   */
  public isDisabled(context: { data: Product }): boolean {
    const product = context.data;
    return TypeUtilService.isTruthy(product.forbiddenChange);
  }

  /**
   * Проверяет доступность команды ограничения счета
   * Команда недоступна если:
   * - На продукте установлен запрет на изменение ограничений (forbiddenChange: true)
   * - На продукте уже установлено полное ограничение (hiddenNotPass: true)
   */
  protected checkAvailability(product: Product): boolean {
    // Преобразуем строковые значения в boolean
    const hiddenNotPass = product.hiddenNotPass === true || product.hiddenNotPass === 'true';

    // Отображаем всегда, кроме случая когда уже есть полное ограничение (жёстко скрыт)
    return !hiddenNotPass;
  }
}
